
<transition name="slide-down">
    <div
        v-if="banner"
        class="NotificationBanner"
        :class="['is-' + banner.type]"
        role="alert"
        aria-live="polite"
    >
        <div class="NotificationBanner-content">
            <i :class="iconClass"></i>
            <div class="NotificationBanner-text">
                <h4 v-if="banner.title" class="NotificationBanner-title">
                    {{ banner.title }}
                </h4>
                <p class="NotificationBanner-message">{{ banner.message }}</p>
            </div>
            <div class="NotificationBanner-actions">
                <a
                    v-if="banner.actionUrl && banner.actionLabel"
                    :href="banner.actionUrl"
                    class="NotificationBanner-action"
                    @click="handleActionClick"
                >
                    {{ banner.actionLabel }}
                </a>
                <button
                    class="NotificationBanner-close"
                    @click="handleDismiss"
                    aria-label="Banner schließen"
                >
                    <i class="ri-close-line"></i>
                </button>
            </div>
        </div>
    </div>
</transition>
